export default __webpack_public_path__ + "static/media/leafcutterbee.6242d0dd.jpeg";